import env from '.env.json';

let config = {};

if (env.DEFAULT_LOCALE === 'vi') {
    config = {
        title: `${env.APP_NAME} | Trang web học tiếng Anh miễn phí`,
        openGraph: {
            url: env.ROOT_URL,
            keywords: 'english, learn english, english top, luyện thi tiếng anh',
            title: `${env.APP_NAME} | Trang web học tiếng Anh miễn phí`,
            description: `${env.APP_NAME} là website học tiếng anh lớn nhất Việt Nam, với bộ ngữ pháp, từ vựng, bài thi và trò chơi giúp cho việc học tiếng anh trở nên dễ dàng hơn bao giờ hết`,
            site_name: env.APP_NAME,
            locale: env.DEFAULT_LOCALE,
            images: [
                {
                    url: `${env.ROOT_URL}/images/commons/image_share.webp`,
                    alt: `${env.APP_NAME} Logo`,
                },
            ]
        },
        twitter: {
            handle: `@${env.APP_NAME}`,
            title: `${env.APP_NAME} | Trang web học tiếng Anh miễn phí`,
            description: `${env.APP_NAME} là website học Tiếng Anh trực tuyến với các chương trình học tập đáp ứng đông đảo đối tượng người học Tiếng Anh, bao gồm bộ từ điển Tiếng Anh với hơn 50.000 từ, ngữ pháp Tiếng Anh thông dụng, các trò chơi phù hợp cho mọi lứa tuổi và đặc biệt là chức năng luyện thi với bộ đề thi vô cùng phong phú. ${env.APP_NAME} sẽ không ngừng phát triển, sử dụng công nghệ vượt trội giúp bạn vươn tầm ước mơ.`,
            site: `@${env.APP_NAME}`,
            keywords: 'english, learn english, english top, English test',
            cardType: 'summary_large_image',
        }
    }
}

if (env.DEFAULT_LOCALE === 'en') {
    config = {
        title: `${env.APP_NAME} | Free English Learning Website`,
        openGraph: {
            url: env.ROOT_URL,
            keywords: 'english, learn english, englook, English test',
            title: `${env.APP_NAME} | Free English Learning Website`,
            description: `${env.APP_NAME} is the largest English learning website in Vietnam, with grammar, vocabulary, tests and games that make learning English easier than ever.`,
            site_name: env.APP_NAME,
            locale: env.DEFAULT_LOCALE,
            images: [
                {
                    url: `${env.ROOT_URL}/images/commons/image_share.webp`,
                    alt: `${env.APP_NAME} Logo`,
                },
            ]
        },
        twitter: {
            handle: `@${env.APP_NAME}`,
            title: `${env.APP_NAME} | Free English Learning Website`,
            description: `${env.APP_NAME} is an online English learning website with learning programs that meet the needs of a wide range of English learners, including an English dictionary with more than 50,000 words, common English grammar, games suitable for all ages and especially a test preparation function with a very rich set of test questions. ${env.APP_NAME} will constantly develop, using superior technology to help you reach your dreams.`,
            site: `@${env.APP_NAME}`,
            keywords: 'english, learn english, englook, English test',
            cardType: 'summary_large_image',
        }
    }
}

export default config;
